(function () {
    'use strict';

    angular
        .module('statistics')
        .controller('StatisticsController', StatisticsController)

    StatisticsController.$inject = ['$uibModal', 'StatisticsService', '$scope', '$interval'];

    function StatisticsController($uibModal, StatisticsService, $scope, $interval) {
        var vm = this;

        vm.queryFlag                    = false;
        vm.expos                        = [];
        vm.expoSelected                 = -1;
        vm.selectExpos                  = selectExpos;
        vm.getExpoStats                 = getExpoStats;
        vm.addRequestOnBackground       = addRequestOnBackground;
        vm.jobs                         = [];
        vm.intervalTime                 = 60*1000*5;
        vm.stats = {
            totalExhibitors: 0,
            totalRepresentatives: 0,
            totalVisitors: 0,
            eventVisitorsAttended: 0,
            totalChats: 0,
            totalChatMessages: 0,
            totalChatsWithCall: 0,
            exhibitors: [],
            lastUpdateAt: null
        }

        function activate() {
            vm.selectExpos();
        }

        function selectExpos () {
            StatisticsService.getAllExpos().then(function(response){
                vm.expos = response.data;
            });
        }

        function getExpoStats() {
            if(vm.expoSelected !== -1){
                vm.queryFlag = true;
                StatisticsService.getExpoStats(vm.expoSelected).then(function(response){
                    vm.stats = response.data;
                })
                vm.addRequestOnBackground();
            }
        }

        function addRequestOnBackground(){
            console.log('aqui')
            if(!vm.jobs.length){
                console.log('registering update on background')
                vm.jobs.push($interval(()=> {
                    console.log('update values', Date.now())
                    vm.getExpoStats();
                }, vm.intervalTime))
            } else {
                console.log('update on background already registered')
            }
        }
        activate();

        $scope.$on('$destroy', function(){
            console.log('clearing background jobs')
            vm.jobs.forEach(job => {
                if(angular.isDefined(job)){
                    $interval.cancel(job)
                }
            })
            vm.jobs = []
        })
    }
})();